/**
 * Sawyer F2 — the one rule for whether an owner's name opens their client
 * profile: a real customer id AND the roles can open `/customers/<id>`.
 *
 * Pure on purpose (functional core): OwnerLink, the Dog ID card's
 * "Owner record →" button and the coverage guard all call this, so the link
 * and the page it lands on are gated by the SAME route rule
 * (`ROUTE_ACCESS_RULES['/customers'] = ['customers:read']`). Whoever can open
 * the profile sees a link; whoever cannot (kennel tech, walker, groomer,
 * signed out) sees plain text and is never sent to "Access restricted".
 *
 * The id alone is not a gate: `/today` sends `customerId` to floor roles too,
 * so "render a link when the id is present" would hand them a dead end.
 */
import { rolesCanAccessPath } from '../../lib/route-permissions.js';

/** The client-profile route for a customer id (always URI-encoded). */
export function ownerProfilePath(customerId: string): string {
  return `/customers/${encodeURIComponent(customerId)}`;
}

export function canOpenOwner(
  roles: ReadonlyArray<string> | null | undefined,
  customerId: string | null | undefined,
): customerId is string {
  if (typeof customerId !== 'string' || customerId.length === 0) return false;
  return rolesCanAccessPath(roles, ownerProfilePath(customerId));
}
